import React from 'react';
import SectionConnect from './sectionConnect';
import SectionServices from './sectionService';

const UpGradFooter = () => {
  return (
    <section className="  bg-black pb-[30px] md:pb-0">
      <div className=" container">
        <div className=" md:px-[70px]">
          <div className=" md:w-[970px] flex flex-col md:flex-row pt-[50px] pb-10 md:py-[45px]  w-full">
            <div className=" md:w-[50%] ">
              <SectionConnect />
            </div>
            <div className="md:w-[50%] ">
              <SectionServices />
            </div>
          </div>
          <div className="pt-[9px] pb-[60px] text-center md:text-left ">
            <p className="text-xs leading-[13px] font-regular text-white"> Copyright © 2023. All rights reserved.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpGradFooter;
